import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { EpaApi } from '../../../../services'
import { IPublicWaterSystem } from '../../../../types'
import { IEventMilestone } from '../../../../types/EventMilestone'

interface RequestOptions {
  pwsId: string,
  options?: AxiosRequestConfig
}

export const fetchPWSEventMilestonesWDescAsync = createAsyncThunk<{}, RequestOptions>(
  'pws/eventmilestoneswdesc/fetch',
  async ({ pwsId, options = {} }, { rejectWithValue }) => {
    try {
      const request = await EpaApi.getPWSEventMilestonesWDesc(pwsId, options) as AxiosResponse<IEventMilestone[]>
      return request.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const fetchPWSEventMilestonesWDescAsyncBuilder = (builder: any) => {
  builder.addCase( fetchPWSEventMilestonesWDescAsync.fulfilled, (state, action) => {

    state.eventMilestones.loading = false
    state.eventMilestones.success = true
    state.eventMilestones.data = action.payload
  })
  builder.addCase( fetchPWSEventMilestonesWDescAsync.rejected, (state, action) => {
    state.eventMilestones.loading = false
    state.eventMilestones.success = false
    state.eventMilestones.error = action.payload
  })
  builder.addCase( fetchPWSEventMilestonesWDescAsync.pending, (state, action) => {
    state.eventMilestones.loading = true
    state.eventMilestones.success = false
    state.eventMilestones.error = ''
  })
}